import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
export default {
  props: {
    data: Object
  },
  data: function () {
    return {
      searchKeyword: ''
    };
  },
  computed: {
    FilteredItems() {
      if (!this.data.items) return [];
      if (!this.searchKeyword) return this.data.items;
      this.data.items.forEach(i => i.selected = false);
      return this.data.items.filter(p => p.title.toLowerCase().replaceAll(' ', '').includes(this.searchKeyword.toLowerCase().replaceAll(' ', '')));
    },
    ItemsStatus() {
      if (!this.data.items) return [];
      return {
        allSelected: this.FilteredItems?.length && this.FilteredItems?.every(s => s.selected),
        selected: this.FilteredItems?.filter(s => s.selected)
      };
    }
  },
  methods: {
    ToggleSelected: function () {
      const toggleTo = !this.ItemsStatus.allSelected;
      this.data.items.forEach(p => p.selected = toggleTo);
    }
  }
};